import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../Common/Breadcrumb"
import ApplicationList from "./ApplicationList"
import PropTypes from "prop-types"
import ReportingBreadcrumbTitle from "../../pages/Reporting/ReportingBreadcrumbTitle"
import ModifiedMetaTags from '../ModifiedMetaTags/index';

const ApplicationListPage = ({title = '', prevTitle = 'Dashboard', prevLink = '/', href = ''}) => {
  return (
    <React.Fragment>
      <div className="page-content">
        <ModifiedMetaTags title={`${title || 'Application'} | Mobihunter`} />

        <Container fluid>
          <Breadcrumbs
            title={prevTitle}
            breadcrumbItem={title}
            link={prevLink}
            customBreadcrumbItem={<ReportingBreadcrumbTitle title={title}/>}
          />

          <ApplicationList
            pathname={href}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

ApplicationListPage.propTypes = {
  title: PropTypes.string,
  prevTitle: PropTypes.string,
  prevLink: PropTypes.string,
  href: PropTypes.string,
}

export default (ApplicationListPage)
